import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        publishedEforms: {
            paginator: {
                rowsByPage: "Resultados por página",
            }
        },
        userActive: {
            dni: "Cédula de identidad",
            cuil: "Cédula de identidad (CI)",
            cuils: "Cédulas de identidad (CI)",
        },
        label: {
            dni: "Cédula de identidad (CI)",
        },
        ei_titleList_text_1_3: "Cédula de identidad *",
        ei_titleList_text_1_4: "Cédula de identidad (CI)",
        ei_titleList_text_3_4: "Departamento",
        ei_titleList_text_3_5: "Provincia",
        ei_titleList_text_3_6: "Municipio",
        head_text_table_search_3: "Cédula de identidad",
        employees_list_search_desc: "Para realizar una búsqueda puede ingresar el Nombre, Apellido, Cédula de identidad o Email del empleado en el campo de búsqueda o seleccionar una combinación de filtros.",
        search_text_1_1: "Cédula de identidad, Nombre, Apellido o Email",
        uploadImageComponent: {
            body: {
                leftContainer: {
                    filter: {
                        cuil: "Cédula de identidad (CI)",
                    }
                },
                noContentEmployeeInfo: {
                    noCuil: 'No posee cédula de identidad (CI)',
                }
            },
            errorLogs: {
                "05115": "La Cédula de identidad (CI) es requerida",
                "05121": "La Cédula de identidad (CI) debe contener entre 5 y 15 caracteres alfanuméricos, los caracteres alfanuméricos deben estar en mayúsculas",
                "05127": "La Cédula de identidad (CI) es duplicada",
            },
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "Identificador",
                    question: "¿Cuál es el Identificador del colaborador?",
                    description: "Ingresa el Identificador del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "Cédula de identidad",
                },
                dni: "CI"
            }
        },
        documentDetail: {
            commons: {
                cuil: "Cédula de identidad (CI)",
            }
        }
    }
})